/**
 * services/api.js
 * Базовый слой HTTP-запросов.
 * Все запросы к бэкенду проходят только через этот модуль.
 * Компоненты никогда не вызывают fetch напрямую.
 */

const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/** Базовая функция запроса */
async function request(endpoint, options = {}) {
  const url = `${BASE_URL}${endpoint}`;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    const error = await response.text().catch(() => 'Unknown error');
    throw new Error(`API ${response.status}: ${error}`);
  }

  return response.json();
}

export const apiService = {
  get:    (endpoint, opts)   => request(endpoint, { method: 'GET', ...opts }),
  post:   (endpoint, body)   => request(endpoint, { method: 'POST',  body: JSON.stringify(body) }),
  put:    (endpoint, body)   => request(endpoint, { method: 'PUT',   body: JSON.stringify(body) }),
  patch:  (endpoint, body)   => request(endpoint, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (endpoint)         => request(endpoint, { method: 'DELETE' }),
};
